import ConsultationsApiClient from '@services/Consultations'
import Customer from '@services/Customer'
import Professional from '@services/Professional'

export function updateServices(jwt) {
  ConsultationsApiClient.updateHeaders({ Authorization: `Bearer ${jwt}` })
  Professional.updateHeaders({ Authorization: `Bearer ${jwt}` })
  Customer.updateHeaders({ Authorization: `Bearer ${jwt}` })
}
export function clearServices() {
  ConsultationsApiClient.removeHeaders()
  Professional.removeHeaders()
  Customer.removeHeaders()
}
